import { appendFormError, validateFormAgreement } from "./inc/formUtils";
import { regExpEmail } from './utils/regex';

// $(".site-header").addClass("home");

const signUpForm = $("#signup_form");
const signUpFormSubmit = $("#signup_submit");
const passwordField = $("#signup_password");
const passwordConfirmField = $("#signup_password_confirm");
const pleaseSpecifyField = $("#field_64").closest(".contribute-form__item-wrap");

pleaseSpecifyField.hide();

function checkPasswordStrength() {
    const passwordEntry = $('.password-entry');
    const passwordEntryConfirm = $('.password-entry-confirm');
    const passwordEntryVal = passwordEntry.val();
    const passwordEntryConfirmVal = passwordEntryConfirm.val();
    const passwordStrengthResult = $('#pass-strength-result');

    passwordStrengthResult.removeClass('short bad good strong');
    passwordStrengthResult.html('');

    if (!passwordEntryVal) {
        return;
    }

    const passwordError = $('<span class="error"></span>');

    if (passwordEntryVal !== passwordEntryConfirmVal) {
        passwordEntry.addClass('error');
        passwordEntryConfirm.addClass('error');
        passwordError.text('Passwords mismatch');
        passwordStrengthResult.append(passwordError);
        passwordStrengthResult.stop(true, true).slideDown(300);
        return;
    }

    if (passwordEntryVal.length < 8) {
        passwordEntry.addClass('error');
        passwordEntryConfirm.addClass('error');
        passwordError.text('Password too short. Must be at least 8 characters.');
        passwordStrengthResult.append(passwordError);
        passwordStrengthResult.stop(true, true).slideDown(300);
        return;
    }

    passwordEntry.removeClass('error');
    passwordEntry.next("span.error").remove();
    passwordEntryConfirm.removeClass('error');
    passwordEntryConfirm.next("span.error").remove();
    passwordStrengthResult.stop(true, true).slideUp(300, function () {
        passwordStrengthResult.find("span.error").remove();
    });
}


// how did you found about us
$("#field_16").on('change', function () {
    ($(this).val() === "Other") ?
        pleaseSpecifyField.stop(true, true).fadeIn(120) :
        pleaseSpecifyField.stop(true, true).fadeOut(120);
});

passwordField.val('').on('keyup input', checkPasswordStrength);
passwordConfirmField.val('').on('keyup input', checkPasswordStrength);

signUpForm.find("input[type='text'], input[type='tel']").each(function () {
    var textField = $(this);
    var labelWrap = textField.parent();

    if (labelWrap.find(".error").length) {
        textField.addClass("error");
    }

    textField.on("keyup focus input", function () {
        if (textField.val() !== '' && (textField.hasClass("error") || labelWrap.find(".error").length)) {
            textField.removeClass("error");
            labelWrap.find(".error").remove();
        }
    });
});

signUpForm.find("input[type='email']").each(function () {
    var eMailField = $(this);
    var labelWrap = eMailField.parent();

    if (labelWrap.find(".error").length) {
        eMailField.addClass("error");
    }

    eMailField.on("keyup focus input", function () {
        if (regExpEmail.test(eMailField.val()) && (eMailField.hasClass("error") || labelWrap.find(".error").length)) {
            eMailField.removeClass("error");
            labelWrap.find(".error").remove();
        }
    });
});

const validateSelect = (field) => {
    let selectVal = field.val();
    const labelWrap = field.parent();

    if (!field.is("#field_16") && (selectVal === 'Please Select' || selectVal === 'Please select' || selectVal === '' || !selectVal.length)) {
        field.next(".select2").addClass("error-select");
        appendFormError(labelWrap, false, "Please choose one of options");
    }

    field.on('change', function () {
        selectVal = field.val();
        if (selectVal !== 'Please Select' && selectVal !== 'Please select' && selectVal !== '' && selectVal.length) {
            field.next(".select2").removeClass("error-select");
            labelWrap.find(".error").remove();
        } else {
            field.next(".select2").addClass("error-select");
            appendFormError(labelWrap, false, "Please choose one of options");
        }
    });
}

const validateTextField = (field) => {
    if ($(field).is("#field_64")) {
        return;
    }
    const labelWrap = field.parent();

    if (field.val() === '' || !field.val() || field.val().length === 0) {
        field.addClass("error");
        appendFormError(labelWrap, false, "Please fill in this field");
    }
}

const validateRadio = (field) => {
    if (!field.attr("required")) {
        return;
    }

    const radioButtonName = field.attr("name");

    if (!signUpForm.find("input[type='radio'][name='" + radioButtonName + "']:checked").length) {
        var errorWrapper = signUpForm.find("input[type='radio'][name='" + radioButtonName + "']:first").closest("div");
        appendFormError(errorWrapper, false, 'Please choose one of variants');
    }

    signUpForm.find("input[type='radio'][name='" + radioButtonName + "']").on("change", function () {
        if (signUpForm.find("input[type='radio'][name='" + radioButtonName + "']:checked").length && errorWrapper.find(".error").length) {
            errorWrapper.find(".error").remove();
        }
    })
}

const validateEmail = (field) => {
    const labelWrap = field.parent();

    if (field.val() === '' || !regExpEmail.test(field.val())) {
        field.addClass("error");
        appendFormError(labelWrap, false, "Please enter valid e-mail address");
    }
}

// TODO: use plugin for validation?
signUpForm.on("submit", function (e) {
    signUpForm.find("select").each((i, field) => validateSelect($(field)));
    signUpForm.find("input[type='text'], input[type='tel'], input[type='password']").each((i, field) => validateTextField($(field)));
    signUpForm.find("input[type='email']").each((i, field) => validateEmail($(field)));
    signUpForm.find("input[type='radio']").each((i, field) => validateRadio($(field)));

    validateFormAgreement(signUpForm);

    if (
        signUpForm.find(".error").length ||
        signUpForm.find(".error-select").length ||
        signUpForm.find('.char-limit-reached').length
    ) {
        e.preventDefault();
    }
});
